export class AlternativeAttributeValueDTO //new AlternativeId
{
    AlternativeId: string;
    AttributeId: number;
    Value: any;
}

export class AttributeFormDefinitionDTO
{
    AlternativeAttributeId: number;
    OverrideName: string;
    OverrideDescription: string;
    OverrideSection: string;
    OverrideOrderValue?: number;
    OverrideRequired?: boolean;
    Readonly: boolean;
}
export class AlternativeStatusDTO
{
    Id: number;
    Name: string;
    OrderValue: number
}

export class SpreadsheetColumnToAlternativePropertyMapping
{
    ColumnName: string;
    PropertyName: string;
    Error: string;
}

export abstract class DefinedValue
{
    Name: string;
    Description: string;
    Value: any;
}

export class RealDefinedValue extends DefinedValue
{
    Value: number;
}

